<template>
  <v-card>
    <v-card-title class="v-toolbar__title black--text font-weight-medium pt-8 bg-custom-light">
      {{ $t('Widgets.installation') }}
      <v-spacer />
      <v-btn class="dialog-close-btn" text @click="$emit('close-installation-modal')">
        <v-icon color="grey darken-1">mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <div class="black--text mt-4">
        {{ $t('Widgets.selectAnInstallation') }}
      </div>
      <installation-dialog-element
        v-if="appBlockLinks.length"
        :title="$t('Widgets.installViaAppBlock')"
        :subtitle="$t('Widgets.installViaAppBlockSubtitle')"
        use-case="via_app_block"
        :app-block-links="appBlockLinks"
        class="mt-4"
        @close-dialog="$emit('close-installation-modal')"
      />
      <installation-dialog-element
        :title="$t('Widgets.requestOpinewInstallation')"
        :subtitle="$t('Widgets.contactOurSupportEngineers')"
        :button-label="$t('Widgets.liveChat')"
        use-case="request_installation"
        class="mt-4"
        image-url="https://cdn.opinew.com/dashboard/images/livechat_icon.svg"
        @close-dialog="$emit('close-installation-modal')"
      />
      <installation-dialog-element
        :title="$t('Widgets.installViaEditor')"
        :subtitle="$t('Widgets.installOpinewSnippets')"
        :button-label="$t('Widgets.editCode')"
        :installation-instructions="installationInstructions"
        use-case="via_editor"
        image-url="https://cdn.opinew.com/dashboard/images/code_icon.svg"
        class="mt-4"
        @close-dialog="$emit('close-installation-modal')"
      />
      <installation-dialog-element
        :title="$t('Widgets.emailInstructionsTo')"
        :subtitle="$t('Widgets.sendInstallationInstructions')"
        :placeholder="$t('Widgets.addEmail')"
        :button-label="$t('Widgets.send')"
        use-case="send_email"
        image-url="https://cdn.opinew.com/dashboard/images/email_icon.svg"
        class="mt-4"
        :instructions-url="instructionsUrl"
        :widget-name="widgetName"
      />
      <installation-dialog-element
        :title="$t('Widgets.installViaBuilder')"
        :subtitle="$t('Widgets.ifYoureUsing')"
        :button-label="$t('Widgets.goToInstructions')"
        use-case="via_builder"
        image-url="https://cdn.opinew.com/dashboard/images/pagebuilder_icon.svg"
        class="mt-4"
      />

      <v-row no-gutters class="mt-8">
        <v-col cols="12">
          <div class="d-flex justify-end">
            <v-btn
              color="black_lighten2"
              class="btn-primary-action"
              outlined
              @click="$emit('close-installation-modal')"
            >
              <span class="black--text"> {{ $t('Widgets.cancel') }} </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import InstallationDialogElement from '@/components/widgets/InstallationDialogElement';
import { getThemeAppBlockLinks } from '@/helpers/themeAppBlockDeepLinks';

export default {
  name: 'InstallationModal',
  components: {
    InstallationDialogElement,
  },
  props: {
    widgetName: {
      type: String,
      default: '',
    },
    widgetKey: {
      type: String,
      default: '',
    },
    instructionsUrl: {
      type: String,
      default: '',
    },
    installationInstructions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['accountInfo']),
    appBlockLinks() {
      return getThemeAppBlockLinks({
        widgetKey: this.widgetKey,
        shopDomain: this.accountInfo.shopDomain,
        apiKey: process.env.VUE_APP_SHOPIFY_PUBLIC_API_KEY,
        t: this.$t.bind(this),
      });
    },
  },
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.stepsBullets {
  border-radius: 100px;
  height: 16px;
  width: 17px;
  font-size: 8px;
  text-align: center;
}

.stepDone {
  background: #2b64c9;
  color: white;
}

.stepPending {
  background: #bfbfbf;
  color: #707070;
}

.profileName {
  font-size: 16px;
  font-weight: bold;
}

.fbText {
  font-size: 16px;
}

.information {
  display: flex;
  flex-direction: column;
}
.well {
  padding: 20px 20px;
  border-radius: 20px;
}
.list-item:first-child {
  margin: 0;
}
.list-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.button {
  margin: auto;
}
.bg-custom-light {
  background: #f3f3f3;
  padding: 16px !important;
}
.dialog-close-btn {
  position: relative;
}

.dialog-close-btn::before {
  background: transparent !important;
}
.dialog-close-btn:hover::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 25%;
  background-color: rgba(138, 138, 138, 0.2);
}
.dialog-close-btn {
  height: 30px !important;
  min-width: 30px !important;
  padding: 0 !important;
}
.dialog-close-btn i {
  font-size: 14px;
}
.dialog-close-btn:hover .v-icon {
  color: #303030 !important;
}
.btn-primary-action.v-btn.v-size--default {
  font-size: 13px !important;
  border-radius: 8px;
  height: 32px;
}
</style>
